import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getInternationalOrdersCount = {
  name: "getInternationalOrdersCount" as const,
  input: z.object({
    teamId: zExt.objectId(),
    days: z.union([z.literal(7), z.literal(30), z.literal(90)]),
  }),
  output: z.object({
    count: z.number(),
    homeCountryCode: z.string().nullable(),
    fetchedAt: z.date(),
    cached: z.boolean(),
    unavailable: z.boolean(),
  }),
};
